// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__yUKO2","rotation":"Loader_rotation__CN15m"};